const styles = (theme) => ({
  container: {
    display: "contents",
    height: "100%",
  },
  mapStyle: { width: "100%" },
  moduleHeader: {
    color: theme.HeaderSelectedText,
    borderBottom: `1px solid ${theme.AppBGColor}`,
    fontWeight: "bold",
    padding: `10px 32px`,
    fontSize: 14,
  },
  subModule: {
    display: "flex",
    height: "94.5%",
  },
  headerIcons: {
    float: "right",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    height: "19px",
    [theme.breakpoints.down("md")]: {
      padding: "3px 8px",
    },
  },
});

export default styles;
